/**
 * /dashboard/change-requests/new — New change-request page (G7.5). Any
 * authed tenant user can submit.
 *
 * The actual form lives in ChangeRequestForm (radio + per-type fields +
 * file inputs); this page only provides the shell + back link.
 *
 * Migration note (Phase 3f — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/change-requests/new/page.tsx.
 * Swaps:
 *   - "use client" dropped
 *   - next/link Link → @tanstack/react-router Link
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { ChangeRequestsShell } from "@/components/change-requests/change-requests-shell";
import { ChangeRequestForm } from "@/components/change-requests/change-request-form";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/change-requests/new",
)({
  component: NewChangeRequestRoute,
});

function NewChangeRequestRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <ChangeRequestsShell
      title="New Change Request"
      description="Ask HR to update your personal details — address, bank account, legal name, nominee, date of birth or anything else. HR reviews each request."
      actions={
        <Button asChild variant="outline" className="gap-1.5">
          <Link to="/app/$tenantSlug/change-requests" params={{ tenantSlug }}>
            <ArrowLeft aria-hidden className="h-4 w-4" />
            Back
          </Link>
        </Button>
      }
    >
      <ChangeRequestForm />
    </ChangeRequestsShell>
  );
}
